import { Box, Typography, Stack, Container, Button } from '@mui/material';
import MainLayout from '@/layouts/MainLayout';
import EmailAccounts from '@/components/EmailAccounts';
import { useUser } from '../../providers/user-provider';

export default function SettingsPage() {
  const { user } = useUser();

  if (user?.subscriptionTier !== 'ENTERPRISE') {
    return (
        <MainLayout>
            <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
                <Box sx={{ maxWidth: 600, mx: 'auto' }}>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Enterprise Feature Only
                    </Typography>
                    <Typography color="text.secondary" paragraph>
                        Email integration and settings are only available for Enterprise accounts.
                        Please upgrade your subscription to access these features.
                    </Typography>
                    <Button variant="contained" href="/dashboard/credits">
                        View Subscription Plans
                    </Button>
                </Box>
            </Container>
        </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Stack spacing={4}>
          <Box>
            <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
              Settings
            </Typography>
            <Typography color="text.secondary">
              Manage your account preferences and integrations.
            </Typography>
          </Box>
          
          <Box>
            <EmailAccounts />
          </Box>
        </Stack>
      </Container>
    </MainLayout>
  );
}
